import AuthenticatedPaths from './AuthenticatedRoutes.paths';
import Component from './AuthenticatedRoutes.component';
import { PERMISSIONS } from '../../authentication/constants';
import { connect } from 'react-redux';
import { fetchUserDetails } from './AuthenticatedRoutes.commands';
import fromState from '../../common/state/selectors';

const mapStateToProps = state => {
    const userId = fromState.Auth.user.getId(state);
    const roles = fromState.DB.user.getEntityFieldById(state, { id: userId, field: 'roles' }) || [];
    const hasPermissionToReadAssessments =
        fromState.Auth.user.hasPermission(state, {
            toPerform: 'read',
            on: PERMISSIONS.ASSESSMENT,
        }) ||
        fromState.Auth.user.hasPermission(state, {
            toPerform: 'read',
            on: PERMISSIONS.ADMIN,
        });

    const hasPermissionToViewAssessments = fromState.Auth.customer.hasPermission(state, {
        toPerform: 'view',
        on: AuthenticatedPaths.ASSESSMENTS,
    });

    const hasPermissionToViewOrganizations = fromState.Auth.user.hasPermission(state, {
        toPerform: 'view',
        on: AuthenticatedPaths.ORGANIZATIONS,
    });

    return {
        isAuthenticated: fromState.Auth.isAuthenticated(state),
        userId: fromState.Auth.user.getEmail(state),
        customerToken: fromState.Auth.getCustomerToken(state),
        roles,
        hasPermissionToReadAssessments,
        hasPermissionToViewAssessments,
        hasPermissionToViewOrganizations,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUserDetails: userId => dispatch(fetchUserDetails(userId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
